import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickCalculatorStep1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 584,
	height: 436,
	viewBox: "0 0 584 436",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M584 382.562H0V382.854H584V382.562Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M525.483 401.355H486.799V401.647H525.483V401.355Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M386.865 404.532H376.715V404.824H386.865V404.532Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M485.631 390.516H463.217V390.808H485.631V390.516Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.719 392.478H61.2734V392.77H111.719V392.478Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.519 392.478H122.126V392.77H129.519V392.478Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.975 397.407H153.557V397.699H262.975V397.407Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.816 330.469H51.287C49.5202 330.466 47.8269 329.762 46.5787 328.511C45.3304 327.261 44.6294 325.566 44.6294 323.8V6.76945C44.6448 5.01281 45.3526 3.33317 46.5992 2.09537C47.8457 0.857568 49.5303 0.161579 51.287 0.158569H276.816C278.585 0.158569 280.281 0.861224 281.532 2.11196C282.783 3.36269 283.485 5.05905 283.485 6.82785V323.8C283.485 325.568 282.783 327.265 281.532 328.516C280.281 329.766 278.585 330.469 276.816 330.469ZM51.287 0.39217C49.5977 0.395264 47.9786 1.06852 46.7851 2.26415C45.5917 3.45979 44.9214 5.08011 44.9214 6.76945V323.8C44.9214 325.489 45.5917 327.109 46.7851 328.305C47.9786 329.501 49.5977 330.174 51.287 330.177H276.816C278.507 330.174 280.127 329.501 281.322 328.306C282.517 327.11 283.19 325.49 283.193 323.8V6.76945C283.19 5.07904 282.517 3.45874 281.322 2.26344C280.127 1.06814 278.507 0.395258 276.816 0.39217H51.287Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M529.466 330.469H303.925C302.157 330.466 300.463 329.762 299.213 328.512C297.963 327.262 297.259 325.568 297.256 323.8V6.76945C297.274 5.01174 297.985 3.33212 299.233 2.09464C300.482 0.85716 302.167 0.161546 303.925 0.158569H529.466C531.221 0.164648 532.902 0.861996 534.146 2.09947C535.39 3.33694 536.096 5.01482 536.112 6.76945V323.8C536.112 325.564 535.412 327.257 534.167 328.507C532.921 329.757 531.231 330.463 529.466 330.469ZM303.925 0.39217C302.235 0.395258 300.614 1.06814 299.419 2.26344C298.224 3.45874 297.551 5.07904 297.548 6.76945V323.8C297.551 325.49 298.224 327.11 299.419 328.306C300.614 329.501 302.235 330.174 303.925 330.177H529.466C531.156 330.174 532.777 329.501 533.972 328.306C535.167 327.11 535.84 325.49 535.843 323.8V6.76945C535.84 5.07904 535.167 3.45874 533.972 2.26344C532.777 1.06814 531.156 0.395258 529.466 0.39217H303.925Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.4511 382.562H81.1992L81.1992 233.21H59.4511L59.4511 382.562Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.1016 382.562H59.4512V354.179H75.1374L67.1016 382.562Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.454 382.562H311.202V233.21H289.454V382.562Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.4513 374.806L296.135 374.806V233.198L59.4513 233.198L59.4513 374.806Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M288.484 382.562H296.135V354.179H280.448L288.484 382.562Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.845 362.659H220.53C219.732 362.656 218.967 362.337 218.403 361.773C217.838 361.209 217.52 360.444 217.517 359.646V247.354C217.52 246.557 217.839 245.793 218.403 245.231C218.968 244.668 219.733 244.352 220.53 244.352H285.845C286.641 244.352 287.404 244.669 287.967 245.231C288.53 245.794 288.846 246.558 288.846 247.354V359.646C288.846 360.443 288.53 361.207 287.968 361.772C287.405 362.337 286.642 362.656 285.845 362.659ZM220.53 245.52C220.288 245.519 220.049 245.565 219.825 245.656C219.601 245.748 219.397 245.883 219.226 246.053C219.054 246.224 218.918 246.426 218.825 246.65C218.732 246.873 218.685 247.112 218.685 247.354V359.646C218.685 360.135 218.879 360.604 219.225 360.95C219.571 361.297 220.041 361.491 220.53 361.491H285.845C286.086 361.491 286.326 361.443 286.549 361.35C286.772 361.257 286.975 361.121 287.145 360.95C287.316 360.778 287.451 360.575 287.542 360.351C287.634 360.127 287.68 359.887 287.678 359.646V247.354C287.678 246.868 287.485 246.401 287.141 246.057C286.797 245.713 286.331 245.52 285.845 245.52H220.53Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.45 362.659H145.136C144.338 362.656 143.575 362.337 143.012 361.772C142.45 361.207 142.134 360.443 142.134 359.646V247.354C142.134 246.558 142.45 245.794 143.013 245.231C143.576 244.669 144.339 244.352 145.136 244.352H210.45C211.247 244.352 212.012 244.668 212.577 245.231C213.142 245.793 213.46 246.557 213.464 247.354V359.646C213.46 360.444 213.142 361.209 212.578 361.773C212.013 362.337 211.248 362.656 210.45 362.659ZM145.136 245.52C144.649 245.52 144.183 245.713 143.839 246.057C143.495 246.401 143.302 246.868 143.302 247.354V359.646C143.3 359.887 143.347 360.127 143.438 360.351C143.529 360.575 143.664 360.778 143.835 360.95C144.005 361.121 144.208 361.257 144.431 361.35C144.654 361.443 144.894 361.491 145.136 361.491H210.45C210.94 361.491 211.409 361.297 211.755 360.95C212.101 360.604 212.296 360.135 212.296 359.646V247.354C212.296 247.112 212.248 246.873 212.155 246.65C212.062 246.426 211.926 246.224 211.754 246.053C211.583 245.883 211.379 245.748 211.155 245.656C210.932 245.565 210.692 245.519 210.45 245.52H145.136Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.056 362.659H69.7415C68.9443 362.656 68.1808 362.337 67.6182 361.772C67.0556 361.207 66.7397 360.443 66.7397 359.646V247.354C66.7397 246.558 67.056 245.794 67.6189 245.231C68.1819 244.669 68.9454 244.352 69.7415 244.352H135.056C135.853 244.352 136.618 244.668 137.183 245.231C137.748 245.793 138.066 246.557 138.07 247.354V359.646C138.066 360.444 137.748 361.209 137.183 361.773C136.619 362.337 135.854 362.656 135.056 362.659ZM69.7415 245.52C69.2552 245.52 68.7887 245.713 68.4448 246.057C68.1009 246.401 67.9077 246.868 67.9077 247.354V359.646C67.9062 359.887 67.9525 360.127 68.044 360.351C68.1354 360.575 68.2703 360.778 68.4407 360.95C68.6111 361.121 68.8138 361.257 69.037 361.35C69.2603 361.443 69.4997 361.491 69.7415 361.491H135.056C135.546 361.491 136.015 361.297 136.361 360.95C136.707 360.604 136.902 360.135 136.902 359.646V247.354C136.902 247.112 136.854 246.873 136.761 246.65C136.668 246.426 136.532 246.224 136.36 246.053C136.189 245.883 135.985 245.748 135.761 245.656C135.538 245.565 135.298 245.519 135.056 245.52H69.7415Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M364.393 350.442H484.802L484.802 30.3864H364.393L364.393 350.442Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M358.459 350.442H483.961L483.961 30.3864H358.459L358.459 350.442Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M364.393 355.966H484.802V350.453H364.393V355.966Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M348.578 355.966H474.08V350.453H348.578V355.966Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M475.668 342.137V38.7026L366.775 38.7026V342.137H475.668Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M391.583 342.137L404.887 38.7026H427.897L414.593 342.137H391.583Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M471.872 129.993C472.042 129.993 472.206 129.926 472.326 129.805C472.447 129.685 472.514 129.521 472.514 129.351V44.087C472.511 43.9187 472.442 43.7583 472.322 43.6403C472.202 43.5223 472.04 43.4563 471.872 43.4563C471.705 43.4563 471.544 43.5228 471.426 43.641C471.308 43.7593 471.241 43.9197 471.241 44.087V129.351C471.241 129.519 471.307 129.681 471.425 129.801C471.543 129.921 471.704 129.99 471.872 129.993Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M419.534 342.137L432.837 38.7026H441.807L428.516 342.137H419.534Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M367.838 342.126V38.6909H366.787V342.126H367.838Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 49.5416H478.845L479.616 41.9263H357.268L356.509 49.5416Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 62.0509H478.845L479.616 54.4355H357.268L356.509 62.0509Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 74.5602H478.845L479.616 66.9565H357.268L356.509 74.5602Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 87.0811H478.845L479.616 79.4658H357.268L356.509 87.0811Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 99.5904H478.845L479.616 91.975H357.268L356.509 99.5904Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M356.509 112.1H478.845L479.616 104.484H357.268L356.509 112.1Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.515 34.0189H98.7778V124.901H261.515V34.0189Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M259.962 34.0189H97.2241V124.901H259.962V34.0189Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.293 113.221V45.6989L108.916 45.6989V113.221L248.293 113.221Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.479 113.233L142.087 45.6989H166.382L157.773 113.233H133.479Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.104 113.233L172.712 45.6989H186.541L177.933 113.233H164.104Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.048 113.233L222.656 45.6989H236.485L227.877 113.233H214.048Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.446 113.221V45.6989H108.916V113.221H110.446Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.501 169.203H258.56V227.79H263.501V169.203Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.87 169.133H261.468V227.72H262.87V169.133Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.374 225.711H268.64C269.286 225.711 269.925 225.838 270.522 226.085C271.118 226.332 271.66 226.695 272.117 227.151C272.574 227.608 272.936 228.15 273.183 228.747C273.43 229.343 273.557 229.983 273.557 230.628V233.338H248.445V230.628C248.445 229.983 248.572 229.343 248.82 228.747C249.067 228.15 249.429 227.608 249.886 227.151C250.342 226.695 250.884 226.332 251.481 226.085C252.077 225.838 252.717 225.711 253.363 225.711H253.374Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.243 229.017V225.022C268.243 224.583 267.888 224.228 267.449 224.228H265.545C265.106 224.228 264.751 224.583 264.751 225.022V229.017C264.751 229.455 265.106 229.811 265.545 229.811H267.449C267.888 229.811 268.243 229.455 268.243 229.017Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.454 176.527H232.607L233.005 175.148C234.774 169.083 238.462 163.755 243.517 159.964C248.571 156.174 254.719 154.124 261.037 154.124C267.355 154.124 273.502 156.174 278.557 159.964C283.611 163.755 287.3 169.083 289.069 175.148L289.454 176.527Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5354 169.203H91.5947V227.79H96.5354V169.203Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.9163 169.133H94.5146V227.72H95.9163V169.133Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.4319 225.711H101.733C102.378 225.711 103.018 225.838 103.614 226.085C104.211 226.332 104.753 226.695 105.21 227.151C105.666 227.608 106.029 228.15 106.276 228.747C106.523 229.343 106.65 229.983 106.65 230.628V233.338H81.4912V230.628C81.4912 229.981 81.6192 229.339 81.8677 228.741C82.1163 228.143 82.4806 227.6 82.9397 227.143C83.3988 226.686 83.9436 226.324 84.5429 226.079C85.1422 225.833 85.7841 225.708 86.4319 225.711Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.277 229.028V225.034C101.277 224.595 100.922 224.239 100.483 224.239H98.5793C98.1406 224.239 97.785 224.595 97.785 225.034V229.028C97.785 229.467 98.1406 229.822 98.5793 229.822H100.483C100.922 229.822 101.277 229.467 101.277 229.028Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.5 176.527H65.6416L66.0504 175.148C67.8194 169.083 71.508 163.755 76.5624 159.964C81.6168 156.174 87.7644 154.124 94.0824 154.124C100.4 154.124 106.548 156.174 111.602 159.964C116.657 163.755 120.345 169.083 122.114 175.148L122.5 176.527Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 435.309C417.072 435.309 518.464 429.389 518.464 422.087C518.464 414.785 417.072 408.865 292 408.865C166.928 408.865 65.5366 414.785 65.5366 422.087C65.5366 429.389 166.928 435.309 292 435.309Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.438 125.672C367.642 123.868 366.633 121.426 366.633 118.88C366.633 116.334 367.642 113.892 369.438 112.088L373.993 107.533C375.797 105.736 378.239 104.727 380.785 104.727C383.331 104.727 385.773 105.736 387.577 107.533C389.368 109.338 390.372 111.777 390.372 114.319C390.372 116.861 389.368 119.3 387.577 121.105L383.01 125.672C381.206 127.462 378.766 128.467 376.224 128.467C373.682 128.467 371.243 127.462 369.438 125.672Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M375.851 119.295C373.531 116.969 372.229 113.819 372.229 110.535C372.229 107.25 373.531 104.1 375.851 101.775L384.774 92.851C387.099 90.5316 390.25 89.229 393.534 89.229C396.818 89.229 399.969 90.5316 402.294 92.851C404.616 95.1749 405.921 98.3257 405.921 101.611C405.921 104.896 404.616 108.047 402.294 110.371L393.347 119.295C391.02 121.601 387.876 122.895 384.599 122.895C381.322 122.895 378.178 121.601 375.851 119.295Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M388.29 106.809C384.324 102.863 378.957 100.648 373.363 100.648C367.768 100.648 362.401 102.863 358.436 106.809L388.29 136.674C392.233 132.705 394.447 127.337 394.447 121.742C394.447 116.146 392.233 110.778 388.29 106.809Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M400.402 164.718C399.922 164.718 399.461 164.527 399.122 164.188C398.782 163.848 398.592 163.388 398.592 162.908C398.592 162.428 398.782 161.967 399.122 161.628C399.461 161.288 399.922 161.097 400.402 161.097C409.076 161.097 417.394 157.652 423.527 151.519C429.66 145.385 433.106 137.067 433.106 128.393C433.106 119.72 429.66 111.401 423.527 105.268C417.394 99.1349 409.076 95.6893 400.402 95.6893C400.153 95.7094 399.902 95.6776 399.666 95.596C399.43 95.5144 399.213 95.3848 399.029 95.2153C398.845 95.0458 398.699 94.84 398.598 94.611C398.498 94.382 398.446 94.1347 398.446 93.8847C398.446 93.6347 398.498 93.3875 398.598 93.1585C398.699 92.9295 398.845 92.7237 399.029 92.5542C399.213 92.3847 399.43 92.255 399.666 92.1735C399.902 92.0919 400.153 92.0601 400.402 92.0802C405.226 91.9937 410.019 92.8691 414.502 94.6555C418.984 96.4419 423.065 99.1033 426.508 102.484C429.95 105.865 432.684 109.899 434.55 114.348C436.417 118.797 437.378 123.574 437.378 128.399C437.378 133.224 436.417 138.001 434.55 142.45C432.684 146.9 429.95 150.933 426.508 154.314C423.065 157.695 418.984 160.356 414.502 162.143C410.019 163.929 405.226 164.805 400.402 164.718Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M444.436 410.535L403.112 214.311L397.587 215.818L419.043 317.668L387.005 410.477H358.494L358.576 409.204H352.21L351.743 416.107H446.094L446.48 410.477L444.436 410.535ZM419.908 321.616L438.596 410.535H389.166L419.908 321.616Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.669 410.535L197.392 214.37L191.867 215.876L213.312 317.726L181.274 410.535H152.728L152.821 409.262H146.444L145.988 416.165H240.328L240.713 410.535H238.669ZM214.141 321.616L232.829 410.535H183.376L214.141 321.616Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M421.963 311.758L416.649 327.14H211.396L216.699 311.758H421.963Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M413.881 323.356L416.649 327.14H211.396L208.628 323.356H413.881Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M413.881 323.356L416.649 327.14H211.396L208.628 323.356H413.881Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.861 288.036H130.162L126.529 284.415L449.259 147.128L452.88 150.749L380.861 288.036Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M380.861 288.036H130.162L126.529 284.415L449.259 147.128L452.88 150.749L380.861 288.036Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M169.013 194.627L162.056 207.9L163.091 208.442L170.047 195.169L169.013 194.627Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.765 212.259L156.458 218.569L157.492 219.112L160.8 212.801L159.765 212.259Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M377.229 284.415H126.529L198.56 147.128H449.259L377.229 284.415Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M352.023 262.398L174.592 263.029L227.082 164.847C269.13 167.86 332.109 168.14 400.997 166.774L352.023 262.398Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M349.465 263.029H173.588L224.116 166.715C278.287 168.724 336.302 167.44 398.79 165.711C389.107 189.982 371.541 225.197 349.465 263.029Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M204.563 251.676C221.095 251.582 237.626 251.504 254.157 251.442L307.359 251.197L334.071 251.068C334.178 251.051 334.275 250.996 334.345 250.914C334.416 250.832 334.454 250.727 334.454 250.619C334.454 250.51 334.416 250.406 334.345 250.323C334.275 250.241 334.178 250.186 334.071 250.169L284.478 250.403L231.276 250.636L204.563 250.765C204.443 250.765 204.327 250.813 204.241 250.898C204.156 250.983 204.108 251.099 204.108 251.22C204.108 251.341 204.156 251.457 204.241 251.542C204.327 251.628 204.443 251.676 204.563 251.676Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M331.887 252.552C342.485 232.384 353.18 212.263 363.972 192.189C367.087 186.412 370.202 180.634 373.316 174.856C373.597 174.342 372.814 173.887 372.534 174.389C361.632 194.455 350.859 214.576 340.215 234.751C337.155 240.537 334.11 246.318 331.081 252.096C330.813 252.61 331.584 253.066 331.864 252.552H331.887Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M373.853 175.277C357.244 175.37 340.639 175.448 324.038 175.51L270.205 175.756L243.575 175.884C243.454 175.884 243.338 175.932 243.253 176.018C243.167 176.103 243.119 176.219 243.119 176.34C243.119 176.461 243.167 176.576 243.253 176.662C243.338 176.747 243.454 176.795 243.575 176.795C260.184 176.702 276.789 176.624 293.39 176.562L347.223 176.316L373.853 176.188C373.974 176.188 374.09 176.14 374.176 176.054C374.261 175.969 374.309 175.853 374.309 175.732C374.309 175.612 374.261 175.496 374.176 175.41C374.09 175.325 373.974 175.277 373.853 175.277Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M246.717 173.642C236.018 194.035 225.206 214.378 214.281 234.67C211.167 240.486 208.029 246.295 204.867 252.096C204.587 252.61 205.37 253.066 205.65 252.552C216.645 232.306 227.546 211.968 238.354 191.535C241.422 185.727 244.482 179.914 247.534 174.097C247.815 173.583 247.032 173.128 246.752 173.642H246.717Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M264.4 241.935L282.656 205.937L287.573 196.266C287.842 195.752 287.059 195.285 286.79 195.81L267.951 232.836L263.571 241.421C263.314 241.946 264.096 242.402 264.353 241.876L264.4 241.935Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M221.067 242.086L231.579 221.413C231.836 220.887 231.053 220.432 230.796 220.946L220.285 241.631C220.028 242.156 220.81 242.612 221.067 242.086Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M324.704 241.935C333.452 226.155 341.173 209.826 349.465 193.801C351.498 189.877 353.553 185.952 355.702 182.121C355.983 181.607 355.2 181.152 354.92 181.666C346.172 197.434 338.439 213.774 330.158 229.787C328.126 233.724 326.07 237.636 323.921 241.467C323.641 241.97 324.412 242.437 324.704 241.923V241.935Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M276.711 241.818C284.653 226.202 292.677 210.609 300.597 194.981L303.283 189.678L304.731 186.817L305.444 185.392C305.642 185.006 305.946 183.932 306.343 183.721C306.928 183.639 307.522 183.639 308.107 183.721H310.338H315.115C322.224 183.651 329.329 183.593 336.431 183.546C343.614 183.546 350.786 183.488 357.969 183.616C358.076 183.599 358.173 183.544 358.243 183.462C358.313 183.38 358.352 183.275 358.352 183.167C358.352 183.058 358.313 182.954 358.243 182.871C358.173 182.789 358.076 182.734 357.969 182.717C340.647 182.413 323.314 182.717 306.004 182.916C305.925 182.914 305.846 182.934 305.776 182.973C305.706 183.012 305.648 183.069 305.607 183.137C295.819 202.631 285.821 222.02 275.928 241.456C275.66 241.981 276.442 242.437 276.711 241.911V241.818Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M324.774 241.596C320.511 226.237 315.43 211.111 310.548 195.95C309.169 191.683 307.799 187.42 306.436 183.161C306.261 182.6 305.385 182.834 305.56 183.394C310.501 198.94 315.687 214.416 320.44 230.021C321.608 233.945 322.776 237.882 323.944 241.841C323.982 241.951 324.06 242.043 324.163 242.098C324.266 242.152 324.386 242.165 324.499 242.133C324.611 242.102 324.707 242.029 324.767 241.929C324.826 241.829 324.846 241.71 324.82 241.596H324.774Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M355.457 182.752C345.81 190.928 335.461 198.17 325.148 205.435C313.982 213.295 302.722 221.016 291.755 229.133C286.335 233.14 280.974 237.239 275.835 241.596C275.391 241.97 276.033 242.612 276.477 242.238C286.312 233.91 296.847 226.435 307.371 219.007C318.455 211.181 329.656 203.507 340.589 195.46C345.868 191.582 351.101 187.611 356.1 183.394C356.544 183.009 355.901 182.378 355.457 182.752Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M275.017 241.689C288.379 242.075 301.741 242.227 315.103 242.238C318.327 242.238 321.562 242.238 324.786 242.168C324.892 242.151 324.99 242.096 325.06 242.014C325.13 241.931 325.168 241.827 325.168 241.719C325.168 241.61 325.13 241.506 325.06 241.423C324.99 241.341 324.892 241.286 324.786 241.269C311.389 241.526 297.922 241.269 284.56 241.012C281.383 240.942 278.194 240.883 275.017 240.79C274.91 240.807 274.813 240.862 274.743 240.944C274.673 241.027 274.634 241.131 274.634 241.24C274.634 241.348 274.673 241.453 274.743 241.535C274.813 241.617 274.91 241.672 275.017 241.689Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M256.493 242.238C265.007 226.388 272.845 210.212 281.102 194.21C283.135 190.254 285.198 186.314 287.293 182.39C287.561 181.876 286.779 181.42 286.51 181.934C277.996 197.784 270.158 213.961 261.901 229.963C259.868 233.922 257.824 237.87 255.71 241.783C255.441 242.297 256.224 242.752 256.493 242.238Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M231.346 242.04C236.672 231.574 242.006 221.113 247.347 210.656C250.01 205.423 252.674 200.19 255.337 194.958C256.645 192.4 257.941 189.83 259.238 187.272C259.658 186.431 260.301 184.305 261.212 183.943C261.986 183.823 262.774 183.823 263.548 183.943H266.141C272.915 183.827 279.701 183.698 286.487 183.943C287.059 183.943 287.059 183.056 286.487 183.032C277.879 182.764 269.271 183.032 260.674 183.161C260.594 183.16 260.516 183.18 260.446 183.219C260.376 183.258 260.318 183.314 260.277 183.383C250.454 202.853 240.491 222.265 230.598 241.701C230.33 242.215 231.112 242.682 231.381 242.157L231.346 242.04Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M256.563 242.016C258.303 222.522 259.284 202.982 261.083 183.5C261.141 182.916 260.242 182.916 260.184 183.5C258.385 202.982 257.404 222.522 255.652 242.016C255.652 242.589 256.504 242.589 256.563 242.016Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M286.615 183.044C272.132 198.672 257.088 213.762 242.383 229.168C238.373 233.35 234.402 237.566 230.47 241.818C230.072 242.238 230.715 242.881 231.112 242.448C245.677 226.68 260.838 211.461 275.683 195.95C279.576 191.886 283.434 187.798 287.258 183.686C287.655 183.266 287.012 182.624 286.615 183.044Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M230.224 241.935C238.832 242.355 247.487 242.729 256.107 242.484C256.691 242.484 256.691 241.561 256.107 241.584C247.487 241.818 238.832 241.456 230.224 241.035C229.64 241.035 229.64 241.911 230.224 241.935Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M244.112 188.288C243.896 188.646 243.753 189.042 243.691 189.455C243.628 189.868 243.649 190.289 243.75 190.694C243.859 191.036 244.053 191.344 244.315 191.59C244.577 191.835 244.897 192.009 245.245 192.096C246.1 192.236 246.975 192.184 247.808 191.943C248.64 191.703 249.408 191.28 250.057 190.706C250.731 190.215 251.271 189.563 251.63 188.811C251.989 188.059 252.155 187.229 252.113 186.396C252.017 185.712 251.664 185.09 251.126 184.656C250.588 184.222 249.905 184.009 249.216 184.06C248.218 184.174 247.294 184.642 246.612 185.38C246.233 185.729 245.874 186.1 245.537 186.49C245.213 186.815 244.976 187.217 244.848 187.658C244.743 188.23 245.619 188.475 245.724 187.903C245.829 187.331 246.483 186.735 246.892 186.326C247.351 185.81 247.906 185.39 248.527 185.088C248.772 184.978 249.038 184.922 249.307 184.922C249.575 184.923 249.841 184.98 250.085 185.09C250.33 185.201 250.549 185.362 250.727 185.562C250.906 185.763 251.04 186 251.12 186.256C251.22 186.866 251.165 187.491 250.961 188.075C250.757 188.658 250.41 189.181 249.952 189.596C248.965 190.625 247.635 191.256 246.214 191.372C245.928 191.413 245.636 191.379 245.366 191.275C245.096 191.171 244.857 190.999 244.673 190.776C244.527 190.464 244.465 190.119 244.492 189.775C244.518 189.432 244.633 189.1 244.824 188.814C245.093 188.3 244.311 187.844 244.042 188.358L244.112 188.288Z",
					fill: "#2771bb"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M221.92 124.072C218.895 129.409 215.823 134.946 212.891 140.424C209.96 145.902 207.051 151.426 204.645 156.939C204.014 158.317 203.477 159.684 202.917 161.051C202.858 161.179 202.917 161.051 202.917 161.051C202.917 161.051 202.917 161.144 202.846 161.237C202.805 161.587 202.805 161.939 202.846 162.289C203.063 163.426 203.42 164.533 203.909 165.582C204.447 166.75 205.077 168.047 205.79 169.297C208.933 174.497 212.421 179.48 216.232 184.212L211.677 189.059C206.255 185.084 201.372 180.424 197.147 175.195C194.697 172.243 192.801 168.871 191.552 165.244C191.182 164.056 190.954 162.829 190.874 161.588C190.835 160.855 190.859 160.121 190.945 159.392C190.985 158.999 191.047 158.61 191.131 158.224C191.131 158.025 191.237 157.815 191.283 157.617L191.435 157.091C191.972 155.479 192.486 153.844 193.07 152.279C195.359 146.141 197.971 140.13 200.896 134.268C203.828 128.428 206.876 122.834 210.24 117.204L221.92 124.072Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.538 182.67L220.752 184.703L215.531 193.509C215.531 193.509 210.953 191.442 210.042 187.249L214.538 182.67Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.255 188.113L223.193 194.899L215.542 193.521L220.763 184.714L229.255 188.113Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M258.221 83.0866C258.046 83.7757 258.221 84.4298 258.724 84.5466C259.226 84.6634 259.681 84.1962 259.892 83.5071C260.102 82.818 259.892 82.1522 259.389 82.0354C258.887 81.9186 258.397 82.3858 258.221 83.0866Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M258.21 84.4182C258.493 86.7436 259.094 89.0192 259.997 91.1809C259.432 91.4032 258.826 91.4987 258.22 91.4603C257.614 91.422 257.025 91.2508 256.493 90.959L258.21 84.4182Z",
			fill: "#ED847E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.68 78.5898C256.605 78.5571 256.541 78.5032 256.496 78.4347C256.451 78.3663 256.427 78.2862 256.427 78.2044C256.427 78.1225 256.451 78.0425 256.496 77.974C256.541 77.9055 256.605 77.8516 256.68 77.8189C257.294 77.5596 257.962 77.4518 258.626 77.5047C259.291 77.5575 259.933 77.7695 260.499 78.1226C260.589 78.1902 260.649 78.2893 260.669 78.3998C260.688 78.5103 260.665 78.6241 260.604 78.7183C260.539 78.8076 260.441 78.8675 260.331 78.885C260.222 78.9025 260.11 78.8762 260.02 78.8117C259.567 78.5395 259.055 78.3786 258.527 78.342C257.999 78.3055 257.47 78.3944 256.983 78.6015C256.885 78.638 256.775 78.6338 256.68 78.5898Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.406 85.7964C235.679 92.2788 236.952 104.157 232.409 108.479C232.409 108.479 234.184 115.066 246.226 115.066C259.483 115.066 252.568 108.479 252.568 108.479C245.327 106.762 245.56 101.389 246.728 96.3551L234.406 85.7964Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M230.189 111.819C229.57 108.315 228.881 104.344 231.17 103.328C233.682 102.16 246.88 102.09 251.143 105.033C255.406 107.977 253.479 114.751 253.479 114.751L230.189 111.819Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.896 409.146C188.253 409.275 188.633 409.331 189.012 409.311C189.391 409.291 189.762 409.195 190.104 409.029C190.238 408.908 190.331 408.749 190.368 408.572C190.406 408.396 190.387 408.212 190.314 408.048C190.272 407.911 190.202 407.785 190.107 407.678C190.012 407.571 189.896 407.486 189.765 407.429C188.597 406.856 185.829 407.978 185.712 408.036C185.674 408.051 185.64 408.076 185.615 408.109C185.591 408.142 185.575 408.182 185.572 408.223C185.572 408.263 185.584 408.303 185.607 408.336C185.63 408.37 185.662 408.395 185.7 408.41C186.402 408.737 187.139 408.984 187.896 409.146ZM189.344 407.732L189.59 407.814C189.665 407.848 189.733 407.898 189.787 407.96C189.842 408.023 189.882 408.096 189.905 408.176C190.022 408.55 189.905 408.667 189.835 408.702C189.356 409.11 187.592 408.702 186.331 408.235C187.29 407.864 188.319 407.712 189.344 407.791V407.732Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.712 408.433H185.805C186.81 408.141 188.959 406.623 188.982 405.618C188.986 405.46 188.934 405.306 188.836 405.183C188.738 405.059 188.599 404.973 188.445 404.941C188.293 404.887 188.131 404.866 187.971 404.878C187.81 404.89 187.653 404.935 187.511 405.011C186.343 405.618 185.583 408.071 185.548 408.176C185.538 408.213 185.538 408.252 185.548 408.289C185.558 408.326 185.579 408.36 185.607 408.386C185.637 408.411 185.673 408.427 185.712 408.433ZM188.211 405.291H188.305C188.562 405.373 188.562 405.501 188.562 405.56C188.562 406.155 187.137 407.347 186.097 407.837C186.371 406.861 186.932 405.99 187.709 405.338C187.877 405.259 188.068 405.242 188.246 405.291H188.211Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.257 413.49C254.425 413.49 255.488 413.327 255.862 412.825C255.958 412.69 256.01 412.529 256.01 412.363C256.01 412.198 255.958 412.037 255.862 411.902C255.79 411.779 255.694 411.672 255.58 411.588C255.465 411.503 255.335 411.443 255.196 411.411C253.724 411.014 250.629 412.778 250.524 412.848C250.486 412.869 250.455 412.902 250.436 412.942C250.417 412.982 250.411 413.027 250.419 413.07C250.427 413.112 250.446 413.15 250.475 413.182C250.504 413.213 250.541 413.235 250.582 413.245C251.466 413.4 252.36 413.482 253.257 413.49ZM254.659 411.774C254.794 411.755 254.932 411.755 255.068 411.774C255.152 411.792 255.231 411.828 255.302 411.878C255.372 411.928 255.431 411.992 255.476 412.066C255.628 412.322 255.57 412.451 255.476 412.533C255.056 413.105 252.813 413.117 251.166 412.883C252.237 412.295 253.411 411.919 254.624 411.774H254.659Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.583 413.245H250.664C251.727 412.766 253.853 410.909 253.689 409.846C253.689 409.613 253.479 409.321 252.907 409.262C252.698 409.24 252.486 409.26 252.285 409.323C252.085 409.385 251.899 409.488 251.739 409.624C250.571 410.547 250.372 412.941 250.372 413.035C250.367 413.072 250.372 413.111 250.386 413.145C250.4 413.18 250.424 413.211 250.454 413.234C250.495 413.249 250.539 413.253 250.583 413.245ZM252.743 409.648H252.86C253.246 409.648 253.269 409.835 253.281 409.881C253.374 410.477 251.937 411.984 250.84 412.649C250.941 411.641 251.348 410.687 252.008 409.916C252.215 409.745 252.474 409.65 252.743 409.648Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240.83 413.035H249.695L250.571 392.501H241.718L240.83 413.035Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.866 406.074L184.521 407.954L193.222 388.834L184.556 386.953L175.866 406.074Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.362 407.078L175.62 404.976C175.449 404.938 175.269 404.961 175.112 405.04C174.955 405.118 174.829 405.248 174.756 405.408L171.381 412.731C171.299 412.911 171.26 413.106 171.265 413.303C171.269 413.499 171.318 413.693 171.408 413.868C171.498 414.043 171.626 414.195 171.783 414.314C171.94 414.433 172.122 414.515 172.315 414.553C175.726 415.231 177.419 415.383 181.659 416.317C184.299 416.889 190.244 418.338 193.876 419.12C197.509 419.903 198.77 416.41 197.38 415.768C191.026 412.86 188.375 410.302 186.646 407.919C186.336 407.49 185.879 407.191 185.362 407.078Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M249.636 412.007H239.954C239.778 412.006 239.607 412.066 239.471 412.177C239.335 412.288 239.241 412.442 239.206 412.614L237.454 420.487C237.41 420.677 237.409 420.875 237.453 421.065C237.496 421.256 237.583 421.434 237.706 421.586C237.828 421.738 237.984 421.86 238.161 421.943C238.338 422.026 238.532 422.067 238.727 422.064C242.231 422.005 247.265 421.807 251.657 421.807C256.784 421.807 261.211 422.087 267.238 422.087C270.871 422.087 271.91 418.408 270.357 418.069C263.43 416.551 257.766 416.387 251.774 412.696C251.138 412.275 250.398 412.037 249.636 412.007Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M267.309 119.189C270.194 125.695 273.347 132.376 276.653 138.765C278.299 141.965 280.016 145.119 281.792 148.109C283.508 151.064 285.404 153.912 287.468 156.636L288.216 157.57C288.403 157.745 288.216 157.663 288.508 157.874C288.974 158.282 289.474 158.649 290.003 158.972C291.405 159.826 292.851 160.606 294.336 161.308C297.466 162.814 300.795 164.263 304.171 165.629C310.91 168.374 317.848 171.002 324.739 173.63L323.057 180.077C315.58 178.877 308.172 177.278 300.865 175.288C297.198 174.237 293.53 173.163 289.828 171.784C287.88 171.065 285.976 170.23 284.128 169.285C283.03 168.716 281.979 168.06 280.986 167.323C280.352 166.846 279.758 166.319 279.21 165.746L278.124 164.578C275.458 161.563 273.025 158.35 270.848 154.965C268.687 151.707 266.736 148.378 264.867 145.014C261.175 138.317 257.86 131.419 254.939 124.352L267.309 119.189Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M213.802 110.488C205.498 112.392 191.552 153.645 191.552 153.645L205.124 158.154C205.124 158.154 218.976 137.632 223.683 127.786C228.601 117.379 222.305 108.537 213.802 110.488Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M213.802 110.488C205.498 112.392 191.552 153.645 191.552 153.645L205.124 158.154C205.124 158.154 218.976 137.632 223.683 127.786C228.601 117.379 222.305 108.537 213.802 110.488Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.483 156.133C207.483 156.133 194.18 153.599 191.131 151.707C190.069 153.248 188.795 158.831 189.66 160.478C190.524 162.125 202.917 164.496 204.598 163.527C206.28 162.557 207.483 156.133 207.483 156.133Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M207.483 156.133C207.483 156.133 194.18 153.599 191.131 151.707C190.069 153.248 188.795 158.831 189.66 160.478C190.524 162.125 202.917 164.496 204.598 163.527C206.28 162.557 207.483 156.133 207.483 156.133Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M219.187 125.135C216.652 127.669 214.351 134.864 214.281 144.009C217.213 139.337 220.238 134.327 222.352 130.321C221.348 126.711 220.226 124.13 219.187 125.135Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.466 110.943C263.466 110.943 272.903 121.596 263.991 187.564H216.582C216.255 180.288 220.822 144.78 213.802 110.476C219.044 109.464 224.346 108.793 229.675 108.467C236.39 108.082 243.121 108.082 249.835 108.467C254.436 108.937 258.993 109.765 263.466 110.943Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M256.434 132.014C257.333 141.638 263.442 153.856 267.016 159.392C267.483 153.038 267.729 147.502 267.799 142.666L256.434 132.014Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.727 117.811C246.016 128.615 275.835 163.749 275.835 163.749L286.254 153.178C286.254 153.178 272.728 129.526 269.551 119.038C265.627 106.073 256.072 109.588 251.727 117.811Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M251.727 117.811C246.016 128.615 275.835 163.749 275.835 163.749L286.254 153.178C286.254 153.178 272.728 129.526 269.551 119.038C265.627 106.073 256.072 109.588 251.727 117.811Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.833 151.088C285.833 151.088 276.793 161.167 273.616 162.768C274.387 164.473 278.486 168.479 280.367 168.608C282.247 168.736 290.657 159.334 290.692 157.395C290.727 155.456 285.833 151.088 285.833 151.088Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M285.833 151.088C285.833 151.088 276.793 161.167 273.616 162.768C274.387 164.473 278.486 168.479 280.367 168.608C282.247 168.736 290.657 159.334 290.692 157.395C290.727 155.456 285.833 151.088 285.833 151.088Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.695 173.747L331.28 170.044L333.955 179.388C333.955 179.388 327.402 183.675 322.158 179.925L322.695 173.747Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M340.857 174.471C340.722 174.561 340.557 174.594 340.397 174.564C340.238 174.533 340.097 174.441 340.005 174.307L330.474 160.175C330.428 160.108 330.395 160.033 330.378 159.954C330.362 159.875 330.361 159.793 330.376 159.714C330.391 159.634 330.422 159.559 330.467 159.492C330.512 159.424 330.57 159.367 330.637 159.322C330.704 159.276 330.779 159.243 330.858 159.227C330.937 159.21 331.018 159.209 331.098 159.224C331.177 159.24 331.253 159.271 331.32 159.315C331.387 159.36 331.445 159.418 331.49 159.485L341.021 173.618C341.067 173.685 341.099 173.76 341.116 173.839C341.133 173.918 341.133 174 341.118 174.079C341.103 174.158 341.072 174.234 341.027 174.301C340.982 174.369 340.925 174.426 340.857 174.471Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M340.332 170.733L344.104 176.316L333.955 179.353L331.28 170.033L340.332 170.733Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M250.571 392.513L250.127 403.095H241.25L241.706 392.513H250.571Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M184.555 386.965L193.222 388.834L188.737 398.692L180.07 396.811L184.555 386.965Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.504 75.6815C233.845 84.3247 232.432 89.3004 235.609 94.7666C240.386 102.943 251.879 101.775 256.084 93.8205C259.88 86.649 261.924 73.7309 254.495 68.2063C252.858 66.9811 250.935 66.1948 248.908 65.9221C246.881 65.6495 244.818 65.8996 242.915 66.6486C241.012 67.3976 239.332 68.6206 238.035 70.2016C236.738 71.7826 235.867 73.6689 235.504 75.6815Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M232.093 71.4066C238.342 69.3626 250.185 64.9592 254.367 75.0157C258.548 85.0722 241.519 95.5725 237.186 95.5842C233.705 95.6192 225.225 73.7426 232.093 71.4066Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.105 75.6464C257.345 82.3624 268.465 72.7031 263.501 61.7823C258.537 50.8615 247.686 52.4383 251.061 57.7644C254.437 63.0904 245.105 55.0196 238.657 57.5074C234.137 59.2477 240 62.086 240.549 64.1416C241.098 66.1973 228.718 66.2557 227.071 69.3392C225.424 72.4228 231.369 78.8468 234.417 77.8423C237.466 76.8378 242.944 74.4434 245.105 75.6464Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.644 80.8207C248.24 82.9697 248.56 85.1921 249.555 87.1395C250.875 89.6858 253.164 88.9266 254.157 86.5088C255.056 84.3247 255.441 80.3768 253.456 78.6365C251.47 76.8962 249.158 78.2394 248.644 80.8207Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M247.172 187.564C247.172 187.564 237.116 255.308 231.591 280.677C225.541 308.476 193.211 397.559 193.211 397.559L177.337 394.125C177.337 394.125 201.55 310.718 204.996 283.165C208.745 253.299 216.582 187.529 216.582 187.529L247.172 187.564Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.007 392.268C197.077 392.268 194.052 398.003 194.052 398.003L176.193 394.137L177.7 388.776L197.007 392.268Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M240.818 211.695C229.138 213.973 230.411 257.352 231.813 279.661C235.165 263.893 240.083 233.548 243.435 212.01C242.623 211.614 241.701 211.503 240.818 211.695Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.968 187.564C263.968 187.564 265.136 253.837 264.225 280.864C263.244 308.978 253.456 401.04 253.456 401.04H238.412C238.412 401.04 237.852 310.625 237.186 283.013C236.462 252.914 232.829 187.564 232.829 187.564H263.968Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.318 395.059C256.388 395.059 255.465 401.297 255.465 401.297H237.198L236.707 395.737L256.318 395.059Z",
			fill: "#2771bb"
		})
	]
});
const ForwardRef = forwardRef(SvgQuickCalculatorStep1);
export default ForwardRef;
